<category-selector>
  <a
    class="x"
    href="#"
    onclick={event => onClose(event)}
  >
    schließen
    <dfk-icon type="cross" width="20px" height="20px"></dfk-icon>
    <div is="fixed-relative"></div>
  </a>
  
  <h2>Themen</h2>

  <div class="mb-4">
    <div is="foldout">
      <div is="dfk-raw" html={t('widget_themen')} class="text-justify" />
    </div>
  </div>

  <div class="d-flex">
    <div class="target w-100"></div>
  </div>

  <script>
    import jquery from 'jquery'
    import * as bs from 'bootstrap'

    import * as d3 from 'd3'
    import Tree from '../lib/tree'
    import DfkInput from '@dfk-paris/frontend/src/components/input.riot'
    import search from '../lib/search.instance'
    import {util} from '@wendig/lib'

    export default class {
      static components = {DfkInput}

      onBeforeMount() {
        search.keywords().then(data => {
          this.update({data})
        })
      }

      onFilter(values) {
        const filter = values['filter']
        this.update({filter})
      }

      onBeforeUpdate() {
        // drop all popovers
        const elements = this.root.querySelectorAll('text[data-id]')
        for (const e of elements) {
          jquery(e).popover('dispose')
        }
      }

      onUpdated(props, state) {
        if (!state.data) return

        const data = this.toHierarchy(state.data)

        const node = Tree(data, {
          label: (e) => {
            let item = e['data']
            return (
              item.count ?
              item.name + ` (${item.count})` :
              item.name
            )
          },
          width: 1024,
          tree: d3.cluster,
          padding: 5,
          viewbox: '-30,-750,750,1230',
          click: (event, d) => {
            const category = this.collectAllActiveNamesFrom(d).join('|')
            props.addFilter({category})
          },
          mouseenter: (event, d) => {
            const desc = d.data.data.description
            if (!desc) return

            const id = d.data.data.name
            const element = document.querySelector(`[data-id='${id}']`)
            if (!element.popoverReady) {
              jquery(element).popover({
                content: desc,
                trigger: 'manual',
                placement: 'left'
              })
              element.popoverReady = true
            }
            jquery(element).popover('show')
          },
          mouseout: (event, d) => {
            const desc = d.data.data.description
            if (!desc) return

            const id = d.data.data.name
            const element = document.querySelector(`[data-id='${id}']`)
            jquery(element).popover('hide')
          }
        })

        const target = this.root.querySelector('.target')
        target.innerHTML = ''
        target.append(node)
      }

      collectAllActiveNamesFrom(d) {
        const children = d.children || []

        if (children.length == 0)
          return [d.data.data['name']]

        let results = []
        for (const c of d.children || []) {
          results = results.concat(this.collectAllActiveNamesFrom(c))
        }
        return results
      }

      buildCountLookup() {
        const result = {}

        for (const bucket of this.props.aggregation.buckets) {
          const {key, doc_count} = bucket
          result[key] = doc_count
        }

        return result
      }

      toHierarchy(data) {
        const counts = this.buildCountLookup()

        const filter = (
          this.state.filter ?
          new RegExp('.*' + util.fold(this.state.filter) + '.*') :
          null
        )
        let result = {name: 'root', children: []}

        let lookup = {}
        let h = {}
        for (const e of data.records) {
          const {c1, c2, c3, description} = e

          if (filter && !util.fold(c3).match(filter, 'i')) continue

          h[c1] = h[c1] || {}
          h[c1][c2] = h[c1][c2] || {}
          h[c1][c2][c3] = h[c1][c2][c3] || {}

          lookup[c3] = {
            name: c3,
            count: 0,
            description
          }
        }

        for (const [k1, v1] of Object.entries(h)) {
          const c1 = {name: k1, children: [], count: 0}
          result['children'].push(c1)

          for (const [k2, v2] of Object.entries(v1)) {
            const c2 = {name: k2, children: [], count: 0}
            c1['children'].push(c2)

            for (const k3 of Object.keys(v2)) {
              const c3 = lookup[k3]
              c2['children'].push(c3)

              // add up counts for all levels
              const c = counts[k3] || 0
              c3['count'] += c
              c2['count'] += c
              c1['count'] += c
            }
          }
        }

        // console.log(result)

        return d3.hierarchy(result)
      }

      onClose(event) {
        event.preventDefault()

        this.props.onClose(event)
      }
    }
  </script>
</category-selector>
